import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import elTranslations from './locales/el.json';

const resources = {
  en: {
    translation: enTranslations
  },
  el: {
    translation: elTranslations
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'el', // Default to Greek
    debug: false,

    interpolation: {
      escapeValue: false // React already escapes values
    },

    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache language selection in localStorage
      caches: ['localStorage'],
      // Key to store language in localStorage
      lookupLocalStorage: 'animap_language'
    }
  });

export default i18n;
